'use client';

import { AnimatedButton } from '@/components/ui/animated-button';
import { Icon } from '@/components/ui/icon';
import { HelpCircleIcon } from '@/components/ui/icon/glyphs';
import { cn } from '@/lib/ui/utils';

interface HowItWorksInfoButtonProps {
  /** Opens the associated how-it-works modal. */
  onClick: () => void;
  /** Required ARIA label — the button has no visible text. */
  ariaLabel: string;
  className?: string;
}

/**
 * Canonical "open the how-it-works modal" affordance — a small, square
 * help-circle icon button matching the proposal header's watchlist button
 * (`AnimatedButton variant="tertiary" size="sm"`, 32px square). Shared across
 * the proposal header, the rating cell, and the backer-rewards card so all
 * three info triggers look and behave identically.
 */
export function HowItWorksInfoButton({
  onClick,
  ariaLabel,
  className,
}: HowItWorksInfoButtonProps): React.ReactNode {
  return (
    <AnimatedButton
      variant="tertiary"
      size="sm"
      onClick={onClick}
      aria-label={ariaLabel}
      className={cn('size-8 shrink-0 p-0', className)}
    >
      <Icon icon={HelpCircleIcon} className="size-4" aria-hidden="true" />
    </AnimatedButton>
  );
}
